import { DatePickerValue, F0DatePicker } from '@factorialco/f0-react'
import { Field } from 'factorial-form'
import type moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { maxDate, minDate } from 'modules/shift_management/lib/getMinMaxDates'

export interface Props {
  startDate: Field
  endDate: Field
  hideLabel?: boolean
  minDateFromLeave?: moment.Moment
  maxDateFromLeave?: moment.Moment | null
}

const RangeDatePicker = ({
  startDate,
  endDate,
  hideLabel = false,
  minDateFromLeave,
  maxDateFromLeave,
}: Props) => {
  const errors = startDate.errors || endDate.errors || []
  const error = errors[0]

  const onChangeEvent = (value: DatePickerValue | undefined) => {
    if (!value) return
    startDate.setErrors([])
    endDate.setErrors([])
    startDate.set(value.value?.from)
    endDate.set(value.value?.to)
  }

  return (
    <F0DatePicker
      size="md"
      hideLabel={hideLabel}
      label={i18n.t('shift_management.no_selection_form.select_period')}
      error={error}
      onChange={onChangeEvent}
      value={{
        granularity: 'range',
        value: {
          from: startDate.value,
          to: endDate.value,
        },
      }}
      minDate={minDateFromLeave?.toDate() || minDate.toDate()}
      maxDate={maxDateFromLeave?.toDate() || maxDate.toDate()}
    />
  )
}

export default RangeDatePicker
